import React, { useState, useEffect } from 'react';
import './styles/App.css';
import { PageLayout } from './components/PageLayout';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useIsAuthenticated } from '@azure/msal-react';
import Button from 'react-bootstrap/Button';
import { loginRequest } from './authConfig';
import { callMsGraph } from './graph';
import { ProfileData } from './components/ProfileData';
import { getMUIComponent } from './components/materialUIComponents';
import { coreSetToken, coreTokenExists } from './components/coreFunctions2';

export default function App(uiSchema) {
    const { instance, accounts, inProgress } = useMsal();
    const [status, setStatus] = useState(null);
    const [initialized, setInitialized] = useState('');
    const [content, setContent] = useState('');
    useEffect(() => {
        async function initialize() {
            if (window.anonymous === "true") {
                if (!initialized){
                    setInitialized();
                    if (coreTokenExists(uiSchema, "props.jsonSchema.options.muiGetSchema")){
                        setContent(await getMUIComponent(uiSchema, uiSchema.props.jsonSchema.options.muiGetSchema));
                    }else{
                        setContent(await getMUIComponent(uiSchema));
                    }
                }
            } else {
                if (!initialized && useIsAuthenticated) {
                    setInitialized();
                    let redirectPromise = await instance.handleRedirectPromise();
                    if (inProgress === "login") {
                        setStatus(<span>Login is currently in progress!</span>);
                    } else if (accounts.length > 0) {
                        setStatus(<span>There are currently {accounts.length} users signed in!</span>);
                        let _logout = () => {
                            instance.logoutRedirect({
                                postLogoutRedirectUri: "/",
                            });
                        }
                        coreSetToken(window, "azureAccount.logout", _logout);
                        setContent(await getMUIComponent(uiSchema));

                    } else {
                        instance.loginRedirect(loginRequest);
                        setStatus(
                            <>
                                <span>There are currently no users signed in!</span>
                            </>
                        );

                    }
                }
            }
        };

        initialize();
    }, []);

    return content;

}